import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
 import CryptoJS from 'crypto-js';
import moment from 'moment';
import { Observable } from 'rxjs';
import { CoreConfigService } from '../../core/core.service';
import { tracking_response_model } from '../tracking-item/tracking-item.model';

@Injectable({
  providedIn: 'root',
})
export class TrackingSearchService {
  constructor(
    private _HttpClient: HttpClient,
    private _CoreConfigService: CoreConfigService
  ) {}

  GetConsignmentListInfo(
    tracking: string[]
  ): Observable<tracking_response_model[]> {
    const _tracking = tracking.join(',');
    const _k = CryptoJS.enc.Utf8.parse(moment().format('YYYY-MM-DD HH:mm'));
    const _track =
      '' +
      CryptoJS.AES.encrypt(_tracking, _k, {
        keySize: 128 / 8,
        iv: _k,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

    const head = new HttpHeaders({
      'kett-id': _track.substr(3, _track.length),
      'kett-ss': _track.substr(0, 3) + this._CoreConfigService.GetGUID(),
    });

    const w = CryptoJS.enc.Utf8.parse(
      tracking.slice(tracking.length - 1, tracking.length)[0]
    );
    const c = CryptoJS.enc.Base64.stringify(w);

    return this._HttpClient.post<any>(
      (this._CoreConfigService.base_config.is_https
        ? 'https://' + this._CoreConfigService.base_config.api_path
        : 'http://' + this._CoreConfigService.base_config.api_path) +
        '/api/Shipment/tracking/' +
        encodeURIComponent(c),
      {
        tracking_no: _tracking,
      },
      {
        headers: head,
      }
    );
  }

  GetConsignmentListInfoฺVerifyPhone(
    tracking: string[]
  ): Observable<tracking_response_model[]> {
    const _tracking = tracking.join(',');
    const _k = CryptoJS.enc.Utf8.parse(moment().format('YYYY-MM-DD HH:mm'));
    const _track =
      '' +
      CryptoJS.AES.encrypt(_tracking, _k, {
        keySize: 128 / 8,
        iv: _k,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

    const head = new HttpHeaders({
      'kett-id': _track.substr(3, _track.length),
      'kett-ss': _track.substr(0, 3) + this._CoreConfigService.GetGUID(),
    });

    const w = CryptoJS.enc.Utf8.parse(
      tracking.slice(tracking.length - 1, tracking.length)[0]
    );
    const c = CryptoJS.enc.Base64.stringify(w);
 console.log(this._HttpClient.post<any>(
  (this._CoreConfigService.base_config.is_https
    ? 'https://' + this._CoreConfigService.base_config.api_path
    : 'http://' + this._CoreConfigService.base_config.api_path) +
    '/api/Shipment/trackingVerifyPhone/' +
    encodeURIComponent(c),
  {
    tracking_no: _tracking,
  },
  {
    headers: head,
  }
))
    return this._HttpClient.post<any>(
      (this._CoreConfigService.base_config.is_https
        ? 'https://' + this._CoreConfigService.base_config.api_path
        : 'http://' + this._CoreConfigService.base_config.api_path) +
        '/api/Shipment/trackingVerifyPhone/' +
        encodeURIComponent(c),
      {
        tracking_no: _tracking,
      },
      {
        headers: head,
      }
    );
  }
}
